import React from 'react';
import { BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { isEmpty } from 'lodash';

function AssetTypeCell(props) {
  const { cell, iconType } = props;

  const { original: rowObj } = cell?.row;

  const { actions } = cell?.column || {};

  const openAssetDetailsTab = () => {
    if (actions.onClick) {
      actions.onClick(cell);
    }
  };

  const imageMap = {
    1: iconType === 'dark' ? 'WindowsDark' : 'Windows',
    2: iconType === 'dark' ? 'LinuxLineIcon' : 'LinuxIcon',
    3: iconType === 'dark' ? 'MacDark' : 'Mac',
    4: iconType === 'dark' ? 'PrinterLight' : 'Printer',
    5: iconType === 'dark' ? 'RouterLight' : 'Router',
    6: iconType === 'dark' ? 'SwitchLight' : 'Switch',
    7: iconType === 'dark' ? 'FireWallLight' : 'FireWall',
    8: 'UPS',
    9: 'LoadBalancer',
    10: 'PowerDevice',
    11: 'Storage',
    12: 'Wan',
    13: 'WireLessAccessPoint',
    14: 'WirelessLanController',
    15: 'Voip',
    16: 'IpCamera',
    17: 'Storage',
    18: 'ServerHardwareController',
    404: 'UnkownIcon'
  };

  const getIcon = () => {
    return imageMap[
      rowObj?.assetClass?.classId ||
        rowObj?.asset?.assetClass?.classId ||
        rowObj?.workStation?.assetClass?.classId ||
        cell?.column?.selectedAssetClass ||
        '404'
    ];
  };

  return (
    <div className="flex-row flex-align-center ignoreOverride">
      {isEmpty(rowObj?.assetClass?.iconClass) ? (
        <SVGIcon name={getIcon()} />
      ) : (
        <SVGIcon name={rowObj?.assetClass?.iconClass} />
      )}

      {cell?.value && (
        <div className="link-block ml-12" onClick={openAssetDetailsTab}>
          {cell.value}
        </div>
      )}
    </div>
  );
}

export default injectIntl(AssetTypeCell);
